(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.classList.contains('is-ready')) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );
      root.querySelectorAll('[data-fq-reveal]').forEach((el) => observer.observe(el));
    };
    const boot = () => document.querySelectorAll('[data-nobo-faq]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Colonnes de liens : accordéons sur mobile, toujours ouvertes sur ordinateur.
    const desktop = window.matchMedia('(min-width: 750px)');

    const apply = () => {
      document.querySelectorAll('[data-nobo-footer-collapsible]').forEach((details) => {
        const summary = details.querySelector('summary');
        if (desktop.matches) {
          details.open = true;
          summary?.setAttribute('tabindex', '-1');
        } else {
          details.open = false;
          summary?.removeAttribute('tabindex');
        }
      });
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('[data-nobo-footer-collapsible] > summary');
      if (summary && desktop.matches) event.preventDefault();
    });

    desktop.addEventListener('change', apply);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply, { once: true });
    } else {
      apply();
    }
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const track = root.querySelector('[data-track]');
      const slides = [...root.querySelectorAll('[data-slide]')];
      const dots = [...root.querySelectorAll('[data-dot]')];
      if (!track || slides.length < 2) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = root.dataset.autoplay === 'true' && !reduce;
      const interval = Number(root.dataset.interval) || 5000;
      let index = 0;
      let timer = null;
      let visible = true;
      let resumeAt = 0;

      const perView = () => Math.max(1, Math.round(track.clientWidth / slides[0].clientWidth));
      const maxIndex = () => Math.max(0, slides.length - perView());

      const goTo = (i) => {
        index = i > maxIndex() ? 0 : Math.max(0, i);
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft });
      };

      const sync = () => {
        const w = slides[0].clientWidth || 1;
        index = Math.round(track.scrollLeft / w);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };

      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          pause();
          goTo(Number(dot.dataset.dot));
        });
      });

      // Après un swipe ou un clic, on laisse la cliente regarder avant de reprendre.
      const pause = () => {
        resumeAt = Date.now() + interval * 2;
      };
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) =>
        track.addEventListener(type, pause, { passive: true })
      );

      const tick = () => {
        if (!visible || document.hidden || Date.now() < resumeAt) return;
        goTo(index + 1);
      };

      if (autoplay) {
        timer = setInterval(tick, interval);
        root.addEventListener('mouseenter', () => (resumeAt = Number.MAX_SAFE_INTEGER));
        root.addEventListener('mouseleave', () => (resumeAt = Date.now() + 800));
      }

      // Les vidéos ne tournent que lorsqu'elles sont à l'écran.
      const videos = root.querySelectorAll('video');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          visible = entries[entries.length - 1].isIntersecting;
        }, { threshold: 0.35 }).observe(root);
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = /** @type {HTMLVideoElement} */ (entry.target);
            if (entry.isIntersecting && !reduce) video.play().catch(() => {});
            else video.pause();
          });
        }, { threshold: 0.35 });
        videos.forEach((video) => videoObserver.observe(video));
      }

      if (reduce) videos.forEach((video) => video.pause());
    };

    const boot = () => document.querySelectorAll('[data-nobo-hero-slider]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.classList.contains('is-ready')) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(root);
    };
    const boot = () => document.querySelectorAll('[data-nobo-ls]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-order-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.classList.contains('is-ready')) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );
      root.querySelectorAll('[data-ns-reveal]').forEach((el) => observer.observe(el));
    };
    const boot = () => document.querySelectorAll('[data-nobo-steps]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const track = root.querySelector('[data-track]');
      const cards = [...root.querySelectorAll('[data-card]')];

      if (!reduce && 'IntersectionObserver' in window) {
        root.classList.add('is-ready');
        let visible = false;
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            visible = entry.isIntersecting;
            if (entry.isIntersecting) root.classList.add('is-in');
          });
        }, { threshold: 0.2 }).observe(root);

        // Défilement automatique doux, en pause dès que la cliente touche la rangée.
        if (track && cards.length > 1) {
          const interval = Number(root.dataset.interval) || 5000;
          let resumeAt = 0;
          const pause = () => (resumeAt = Date.now() + interval * 2);
          ['pointerdown', 'wheel', 'touchstart'].forEach((t) => track.addEventListener(t, pause, { passive: true }));
          root.addEventListener('mouseenter', () => (resumeAt = Number.MAX_SAFE_INTEGER));
          root.addEventListener('mouseleave', () => (resumeAt = Date.now() + 800));
          setInterval(() => {
            if (!visible || document.hidden || Date.now() < resumeAt) return;
            // Carte suivante, toujours alignée : centrée sur mobile, calée au début sinon.
            const centered = window.matchMedia('(max-width: 749px)').matches;
            const trackRect = track.getBoundingClientRect();
            const padStart = parseFloat(getComputedStyle(track).paddingLeft) || 0;
            const targetOf = (card) => {
              const r = card.getBoundingClientRect();
              const offset = centered ? (track.clientWidth - r.width) / 2 : padStart;
              return track.scrollLeft + (r.left - trackRect.left) - offset;
            };
            let current = 0;
            cards.forEach((card, i) => {
              if (Math.abs(targetOf(card) - track.scrollLeft) < Math.abs(targetOf(cards[current]) - track.scrollLeft)) current = i;
            });
            const atEnd = current >= cards.length - 1 || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            track.scrollTo({ left: targetOf(atEnd ? cards[0] : cards[current + 1]) });
          }, interval);
        }
      }
    };
    const boot = () => document.querySelectorAll('[data-nobo-reviews]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
